import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoSparkles } from 'react-icons/io5';
import { MdArrowForward } from 'react-icons/md';
import './AIAgentBanner.css';

export default function AIAgentBanner() {
    const { t } = useTranslation();
    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '60px', marginBottom: '0px' }}>
            <div className="ai-agent-banner-container" style={{ marginTop: '0px' }}>
                <div className="ai-agent-banner-content">
                    <IoSparkles size={24} className="ai-agent-banner-icon" />
                    <span className="ai-agent-banner-text">
                        {t('salesPage.aiAgentBanner')}
                    </span>
                </div>
            </div>
        </div>
    );
}
